import { Helmet } from 'react-helmet';
import TariffsAndRulesPublic from 'src/features/Public/TariffsAndRules';

const TariffsAndRulesPublicPage = () => {
  return (
    <>
      <Helmet>
        <title>Tariffs and Rules</title>
      </Helmet>
      <TariffsAndRulesPublic />
    </>
  );
};

export default TariffsAndRulesPublicPage;
